import type { FaireProductEntity } from "../../entity_types/product";

export const p_wvh7te9wev: FaireProductEntity = {
  token: "p_wvh7te9wev",
  type: "product",
  name: "Candle Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/088b68e5112c0d2217a2d757c26cbb65342a232086b14a4d47a0cb848780dc8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55ef6d5cb7a5f09409686e7138867906c144ea6f05ca013c9a25641895ae5dd0.jpeg",
    "https://cdn.faire.com/fastly/a1bd6a89aa21b81ceefcd4ed86a75890c413547bdf4acdb557e9d91973db59df.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/eb596e64f7421dab1070c73e6c85d91a9d4832a3be8cc7d3c72e30094a74ffad.jpeg",
    "https://cdn.faire.com/fastly/59f2c307dc6894a7e8cc1692d951bebb51f834f2b424ee84581a7673912382a7.jpeg"
  ],
  priceDollars: 6.75,
  description: "Some people burn the candle at both ends. You burn five at once and call it \"layering fragrances.\"\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:22.547Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
